import React from 'react';
import { motion } from 'framer-motion';
import { ProductGallery } from '../components/sections/ProductGallery';
import { CTASection } from '../components/sections/CTASection';

export const GalleryPage = () => {
  return (
    <main data-testid="gallery-page">
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1920&q=80"
            alt="Gallery"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-leather/80"></div>
        </div>
        <div className="relative text-center z-10 px-4">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-gold font-body text-sm uppercase tracking-widest"
          >
            Our Collection
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4"
          >
            Couch Gallery
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-white/70 font-body mt-4 max-w-2xl mx-auto"
          >
            Browse our handcrafted collection of premium couches. Each piece showcases our commitment to quality and style.
          </motion.p>
        </div>
      </section>

      {/* Full Gallery */}
      <ProductGallery showAll={true} />

      {/* CTA */}
      <CTASection />
    </main>
  );
};

export default GalleryPage;
